module.exports = __webpack_public_path__ + "favicon-57-2766d74d6dfec9caf7021e3e7cfc62e7.bundle.png";